// auto-generated by Typewriter template _enums.tst from PortCall.Models\DomainSettings\DateTimeDisplaySettings.cs
export enum DateDisplayOrder { 
    MonthDayYear = 0,
    DayMonthYear = 1,
    YearMonthDay = 2
}

export const DateDisplayOrderDisplayName : { [val : number] : string } = { 
    0: 'MonthDayYear',
    1: 'DayMonthYear',
    2: 'YearMonthDay'
}

export const DateDisplayOrders : { Id : DateDisplayOrder, Name : string }[] = [ 
    { Id: DateDisplayOrder.MonthDayYear, Name: 'MonthDayYear' },
    { Id: DateDisplayOrder.DayMonthYear, Name: 'DayMonthYear' },
    { Id: DateDisplayOrder.YearMonthDay, Name: 'YearMonthDay' }
]



// WEBPACK FOOTER //
// ./server/enums/DateDisplayOrder.ts